<template>
    <div class="page">
        <div class="logo">
            <a href="https://samgk.ru" target="_blank"><img :src="require('@/assets/images/logo.png')" alt=""></a>
        </div>
        <div class="container flex flex-col items-center mx-auto h-full">
            <p class="title md:mt-5">Наши викторины</p>
            <div class="row w-full mt-5 pb-5 justify-center overflow-y-auto" style="max-height: calc(100vh - 10rem)">
                <div class="col-12 md:col-6 lg:col-4 xl:col-3 px-2 pt-6" v-for="(quiz, index) in quizes" :key="'quiz_'+index">
                    <div class="quiz-card" :class="(quiz.status == 0 || quiz.status == 2) ? 'disabled' : quiz.color" @click="GoToQuiz(quiz.status, index)" @mouseover="quiz.__isHovered = true" @mouseout="quiz.__isHovered = false">
                        <div class="quiz-card-statusbar">
                            <button class="quiz-card-button" v-if="quiz.__isHovered && quiz.status != 0 && quiz.status != 2">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                                    <path fill-rule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                        <div class="quiz-card-description">&#160;</div>
                        <div class="quiz-card-title" v-if="quiz.status == 2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 animate-spin mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                            </svg>
                            В разработке
                        </div>
                        <div class="quiz-card-title" v-else>{{quiz.title}}</div>
                        <div class="quiz-card-image">
                            <img :src="quiz.image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            quizes: []
        }
    },
    methods: {
        GoToQuiz(status, index) {
            if (status == 1)
                this.$router.push({name: "Quiz", params: {id: index}})
        }
    },
    async mounted() {
        this.quizes = await this.$root.GetQuizes()
    },
}
</script>